export default {
  ZH_HK: {
    title: "裁剪圖片",
    cancel: "取消",
    crop: "裁剪"
  },
  EN: {
    title: "Crop picture",
    cancel: "Cancel",
    crop: "Crop"
  },
  zh_cn: {
    title: "裁剪图片",
    cancel: "取消",
    crop: "裁剪"
  },
  es: {
    title: "Recortar imagen",
    cancel: "Cancelar",
    crop: "Recortar"
  }
};
